import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  className?: string;
  title?: string;
  description?: string;
  Icon?: LucideIcon;
};

export const EmptyPlaceholder = ({
  className,
  title = 'There are no any items yet.',
  description,
  Icon,
}: Props) => {
  return (
    <div className={cn('flex flex-col items-center gap-1 pt-12 text-center', className)}>
      {Icon ? <Icon className="text-muted-foreground" /> : null}
      <p>{title}</p>
      {description ? <p className="text-muted-foreground text-sm">{description}</p> : null}
    </div>
  );
};
